module.exports = __webpack_public_path__ + "img/609-normal.320840a0.jpg";